import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'carbon_intensity_scope'

export const dataPointDefinition = {
  retracedId: 'carbon_intensity_scope',
  name: 'What is your current carbon intensity?',
  meta: {
    isMultipleRow: false,
    columns: [
      {
        key: 1,
        id: 'carbon_intensity_scope1',
        name: 'SCOPE_1',
        text: 'Scope 1',
        type: 'NUMBER_UOM',
        unit: 'METRIC_TON',
        unitText: 'Mt CO₂',
      },
      {
        key: 2,
        id: 'carbon_intensity_scope2',
        name: 'SCOPE_2',
        text: 'Scope 2',
        type: 'NUMBER_UOM',
        unit: 'METRIC_TON',
        unitText: 'Mt CO₂',
      },
      {
        key: 3,
        id: 'carbon_intensity_scope3',
        name: 'SCOPE_3',
        text: 'Scope 3',
        type: 'NUMBER_UOM',
        unit: 'METRIC_TON',
        unitText: 'Mt CO₂',
      },
    ],
  },
  fieldTypeId: 'TABLE',
  type: 'RELATIONAL',
  options: [
    {
      unit: [
        {
          key: 'METRIC_TON',
          text: 'Metric ton',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'object',
        properties: {
          unit: {
            type: 'string',
            enum: ['METRIC_TON'],
          },
          carbonIntensityScope1: {
            type: 'number',
          },
          carbonIntensityScope2: {
            type: 'number',
          },
          carbonIntensityScope3: {
            type: 'number',
          },
        },
        required: ['carbonIntensityScope1', 'unit', 'carbonIntensityScope2', 'carbonIntensityScope3'],
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 610,
  sectionId: '2.1.5.1',
  impactArea: 'GHG Emissions',
  impactAreaId: 'GHG_EMISSIONS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
